/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { Configuration, LogLevel, RedirectRequest } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID || '', // This is the ONLY mandatory field that you need to supply.
    authority: process.env.REACT_APP_MSAL_AUTHORITY_SIGN_IN || '', // Defaults to "https://login.microsoftonline.com/common"
    redirectUri: '/', // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    knownAuthorities: [process.env.REACT_APP_MSAL_AUTHORITY || ''], // An array of URIs that are known to be valid. Used in B2C scenarios.
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  // system: {
  //   loggerOptions: {
  //     loggerCallback: (level: any, message: any, containsPii: any) => {
  //       if (containsPii) {
  //         return;
  //       }
  //       switch (level) {
  //         case LogLevel.Error:
  //           console.error(message);
  //           return;
  //         case LogLevel.Info:
  //           console.info(message);
  //           return;
  //         case LogLevel.Verbose:
  //           console.debug(message);
  //           return;
  //         case LogLevel.Warning:
  //           console.warn(message);
  //           return;
  //         default:
  //           return;
  //       }
  //     },
  //   },
  // },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest: RedirectRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    'offline_access',
    process.env.REACT_APP_MSAL_SCOPE_USER_API || '',
  ],
  extraQueryParameters: { appName: 'trulladirect' },
};

/**
 * Configuration for a password change request
 */
export const changePasswordRequest: RedirectRequest | any = {
  scopes: ['openid'],
  authority: process.env.REACT_APP_MSAL_AUTHORITY_PASSWORD_CHANGE || '',
  redirectUri: '/',
  prompt: 'none',
  responseMode: 'fragment',
  response_type: 'code',
  extraQueryParameters: { appName: 'trulladirect' },
};

/**
 * Configuration for a token which can view and manage User Onboard Requests
 *
 */
export const onboardTokenRequest: RedirectRequest | any = {
  scopes: [
    process.env.REACT_APP_MSAL_SCOPE_REQUESTS_MANAGE || '',
    process.env.REACT_APP_MSAL_SCOPE_REQUESTS_VIEW || '',
  ],
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
// export const silentRequest = {
//   scopes: ['openid', 'profile'],
//   loginHint: 'example@domain.net',
// };

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: 'Enter_the_Graph_Endpoint_Here/v1.0/me',
};
